import { Tooltip } from "antd";
import { Field } from "formik";

export const FormikInput = ({
	value,
	error,
	placeholder,
	label,
	className,
	type,
	icon,
	iconClick,
	contactField,
	inputClassName,
	fieldValue,
	isDisabled,
	tooltipTitle,
	toolTipIcon,
}) => {
	return (
		<div className={className}>
			<label htmlFor={value} className="form-label ff f14 ff_bd text-black">
				{label}
				{tooltipTitle && (
					<Tooltip title={tooltipTitle} className="ms-2 ff" overlayInnerStyle={{ fontFamily: "Nunito", fontSize: "1rem" }}>
						<span className="position-absolute">{toolTipIcon}</span>
					</Tooltip>
				)}
			</label>
			<div className="position-relative">
				{fieldValue ? (
					<Field
						type={type}
						className={`
                        form-control form-control-lg
                        ${icon && "pe-5"}
                        ${inputClassName && inputClassName}`}
						id={value}
						name={value}
						placeholder={placeholder}
						autoComplete={"false"}
						value={fieldValue}
						disabled={isDisabled}
					/>
				) : (
					<Field
						type={type}
						className={`form-control form-control-lg ${icon && "pe-5"} ${inputClassName && inputClassName}`}
						id={value}
						name={value}
						placeholder={placeholder}
						autoComplete={"false"}
						disabled={isDisabled}
					/>
				)}

				{contactField && contactField}
				{icon && (
					<span
						className="cursor-pointer password_show_hide position-absolute"
						onClick={(e) => {
							e.stopPropagation();
							iconClick();
						}}
					>
						{icon}
					</span>
				)}
			</div>
			<small className="text-danger d-block F12">
				{error}
				&nbsp;
			</small>
		</div>
	);
};
export const FormikTextArea = ({ value, error, placeholder, label, className, type, classNameField, disabled }) => {
	return (
		<div className={className}>
			<label htmlFor={(value, type)} className="form-label ff_bd fs-6 ff text-black mb-1">
				{label}
			</label>
			<div className={classNameField}>
				<Field as="textarea" type={type} className="form-control form-control-lg border-0" id={value} name={value} placeholder={placeholder} rows="4" disabled={disabled} />
				<small className="text-danger d-block">
					{error}
					&nbsp;
				</small>
			</div>
		</div>
	);
};
